import { Phone } from "lucide-react";
import { TEL } from "./shared";

export default function StickyCall() {
  return (
    <a
      href={TEL}
      data-testid="sticky-call-button"
      className="fixed bottom-6 right-6 z-50 bg-teal text-white rounded-full px-6 py-4 shadow-xl hover:scale-105 hover:bg-teal-dark transition-all flex items-center gap-2 md:hidden"
    >
      <Phone size={20} strokeWidth={1.5} /> Call Now
    </a>
  );
}
